import { render, staticRenderFns } from "./formAttach.vue?vue&type=template&id=945d7050&scoped=true&"
import script from "./formAttach.vue?vue&type=script&lang=js&"
export * from "./formAttach.vue?vue&type=script&lang=js&"
import style0 from "./formAttach.vue?vue&type=style&index=0&id=945d7050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d7050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('945d7050')) {
      api.createRecord('945d7050', component.options)
    } else {
      api.reload('945d7050', component.options)
    }
    module.hot.accept("./formAttach.vue?vue&type=template&id=945d7050&scoped=true&", function () {
      api.rerender('945d7050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formAttach.vue"
export default component.exports